import classNames from 'classnames';

import useNavigateWithSearch from '../../../../hooks/useNavigateWithSearch';
import Button, { BUTTON_TYPE } from '../Button/Button';
import './ItemListContainer.scss';

const ItemListContainer = ({ listTitle, items, exitIcon, className }) => {
  const navigateWithSearch = useNavigateWithSearch();

  return (
    <div className={classNames('ItemListContainer', className)}>
      <div className="ItemListContainer__title">{listTitle}</div>
      {items.map(({ label, route, icon, title, external = false }) => (
        <Button
          key={title}
          type={BUTTON_TYPE.SENARY}
          className="ItemListContainer__item"
          onClick={() => {
            if (external) {
              window.open(route);
              return;
            }

            navigateWithSearch(route);
          }}
        >
          <div className="ItemListContainer__item-content">
            <img className="ItemListContainer__item-icon" src={icon} alt="edit" />
            <div className="ItemListContainer__item-text">
              <span className="ItemListContainer__item-title">{title}</span>
              {label && <span className="ItemListContainer__item-label">{label}</span>}
            </div>
            <img className="ItemListContainer__item-icon" src={exitIcon} alt="edit" />
          </div>
        </Button>
      ))}
    </div>
  );
};

export default ItemListContainer;
